/**
 * Fragment de routes du paquet v8d-p01-fiche-workflow-ecrans (vague V8d, règle R2 du découpage V4–V11 : un fragment par
 * paquet). Composant chargé à la demande (règle de chargement du registre). Route neuve, aucun remplacement du socle :
 *  - `/org/workflows/:workflowId` → organisation-workflow-fiche (lecture, D8).
 * L'écran `organisation-workflow-editeur` est reporté (D8, constat K7) : aucune route.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const OrganisationWorkflowFiche = lazy(() => import('../ecrans/v8d/workflow/OrganisationWorkflowFiche'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v8d-workflow',
  routes: [
    { chemin: '/org/workflows/:workflowId', element: ecran(OrganisationWorkflowFiche) },
  ],
}
